import { CostChannel } from '@sg/graphql-schema';

import { useQuickAddProductForRestaurantQuery } from '../../graphql/QuickAddProduct.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useQuickAddRemoteData = (params: Params) => {
  const { baseProductSlug, selectedDeliveryAddressId, selectedRestaurantId } = params;

  const costChannel = selectedDeliveryAddressId
    ? CostChannel.DeliveryCostChannel
    : CostChannel.DefaultCostChannel;

  // ─── Remote Data ─────────────────────────────────────────────────────

  const [productResponse] = useQuickAddProductForRestaurantQuery({
    pause: !baseProductSlug || !selectedRestaurantId,
    requestPolicy: 'network-only',
    variables: {
      baseProductSlug: baseProductSlug ?? '',
      restaurantId: selectedRestaurantId ?? '',
      costChannel,
    },
  });

  // ─── Derived ─────────────────────────────────────────────────────────

  const isFetchingProduct = productResponse.fetching;
  const productForRestaurant = productResponse.data?.productForRestaurant ?? undefined;
  const hasNoProductData = !isFetchingProduct && !productForRestaurant;
  const isUnavailableProduct = hasNoProductData || productForRestaurant?.outOfStock === true;

  // ─────────────────────────────────────────────────────────────────────

  return {
    isFetchingProduct,
    isUnavailableProduct,
    productForRestaurant,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  baseProductSlug?: string;
  selectedDeliveryAddressId?: string;
  selectedRestaurantId?: string;
};
